import { exportsModule } from '@cian/mf-registry/browser';

import { createCustomElementConstructor } from './createCustomElementConstructor';
import { V3_RECOMMENDATIONS_RUNTIME_NAME } from '../../shared/constants/runtimeNames';
import { createApplicationContext } from '../services/applicationContext/createApplicationContext';
import { IAppState } from '../../shared/types';
import { mlSearchSession } from '../../shared/utils/mlSearchSession';
import { createReduxStore } from '../../shared/utils/redux';

export function start() {
  const context = createApplicationContext();

  const initialState = context.config.getStrict<IAppState>('initialState');

  mlSearchSession.init();

  const store = createReduxStore(context, initialState, true);

  exportsModule({
    ui: {
      [V3_RECOMMENDATIONS_RUNTIME_NAME]: () => ({
        customElementConstructor: createCustomElementConstructor(context, store),
      }),
    },
  });
}
